import {
  type ExportSearchResultsSourceFeature,
  useExportSearchResultsMutation,
} from '@exam-management/graphql';
import { useAuth } from '@shared/auth';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Flex,
  Grid,
  Text,
} from '@shared/components';
import { useSnackbar } from '@shared/snackbar';

interface ExportSearchResultsModalProps {
  open: boolean;
  onClose: () => void;
  questionIds: string[];
  sourceFeature: ExportSearchResultsSourceFeature;
  page: number;
  pageSize: number;
  total: number;
}

export default function ExportSearchResultsModal(props: Readonly<ExportSearchResultsModalProps>) {
  const { open, onClose, questionIds, sourceFeature, page, pageSize, total } = props;

  const { userProfile } = useAuth();
  const { showSnackbar } = useSnackbar();

  const [exportSearchResults, { loading }] = useExportSearchResultsMutation({
    onCompleted: () => {
      showSnackbar({
        variant: 'success',
        message: "Processing. The file will be sent to your email when it's ready.",
      });
      onClose();
    },
    onError: () => {
      showSnackbar({
        variant: 'error',
        message: 'ไม่สามารถ Export ได้ในขณะนี้ กรุณาลองใหม่อีกครั้ง',
      });
    },
  });

  const handleExport = () => {
    exportSearchResults({
      variables: { input: { questionIds, sourceFeature, page, pageSize } },
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs' fullWidth>
      <DialogTitle onClose={onClose}>Export Search Results</DialogTitle>
      <Divider />
      <DialogContent>
        <Flex sx={{ flexDirection: 'column', gap: 1.5 }}>
          <Text variant='body1Semibold'>สรุปข้อมูลที่ต้องการ</Text>
          <Grid sx={{ gridTemplateColumns: '100px auto', gap: 1.5, columnGap: 2 }}>
            <Text variant='body1Semibold'>รวมทั้งหมด:</Text>
            <Text variant='body1'>{total} รายการ</Text>
            <Text variant='body1Semibold'>ส่งไปที่:</Text>
            <Text variant='body1'>{userProfile?.email}</Text>
          </Grid>
        </Flex>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button
          color='secondary'
          variant='outlined'
          size='large'
          onClick={onClose}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button size='large' loading={loading} onClick={handleExport}>
          Export
        </Button>
      </DialogActions>
    </Dialog>
  );
}
